import React from 'react';
import './goodend.scss';

class GoodendPage extends React.Component {
	tid = 0;
	constructor(props){
		super(props);
		this.state = {
			list:[],
			fin:false,
		};
	}
	componentDidMount(){
		let n = 0;
		this.tid = setInterval( ()=>{
			let list = this.state.list;
			if( this.props.data.list[n] ){
				list.push( this.props.data.list[n] );
				this.setState({list:list});
				n++;
			} else {
				this.setState({fin:true});
				clearInterval( this.tid );
			}
		},250);
	}
	componentWillUnmount (){
		clearInterval( this.tid );
	}
	render (){
		const num = this.props.data.list.length;
		const list = this.state.list.map( (name,index)=>{
			const key = "name"+index;
			const no = index+1;
			return (
				<li key={key}>
					{no}. {name}
				</li>
			);
		})
		return (
			<div id="goodend" className="modal">
				<div className="list">
					<p>活動家名簿</p>
					<ul>
						{num===0 &&
						<li>なし</li>
						}
						{list}
					</ul>
				</div>
				{this.state.fin && 
				<React.Fragment>
				{num>0 ? (
				<div className="result">
					<p>マリーとコリーはタイムリミットまでに{num}人の活動家を首都に送り込むことに成功した。</p>
					<p>計画に従い彼らは行動を開始する。革命万歳、マイクに拾われた小さな声が誰の声だったかは、後々まで学者たちの意見が分かれる謎の一つになった。</p>
				</div>
				):(
				<div className="result">
					<p>マリーとコリーは活動家を首都に送り込むことはできなかった。</p>
				</div>
				)}
				</React.Fragment>
				}
				<div className="arrow"
					onClick={()=>this.close()}
				>
					<p>
						<i className="fas fa-check"></i>
					</p>
				</div>
			</div>
		)
	}

	close (){
		this.props.close();
	}

	goTop (){
		this.props.setState({mode:"result"});
	}
}

export default GoodendPage;